export default {
  "about": {
    "careersDetails": {
      "anqing": "Anqing",
      "applyResume": "Enviar currículum",
      "backToPrevious": "Volver a la página anterior",
      "category": "Categoría:",
      "education": "Educación mínima:",
      "errors": {
        "getInfoFailed": "Fallo al obtener información",
        "getJobDetailFailed": "Fallo al obtener detalles del puesto",
        "getJobDetailFailedRetry": "Fallo al obtener detalles del puesto, intente nuevamente más tarde",
        "jobNotExist": "La información del puesto no existe",
        "parseInfoFailed": "Fallo al analizar la información"
      },
      "jobDescription": "Descripción del puesto",
      "jobRequirements": "Requisitos del puesto",
      "nationwide": "Todo el país",
      "noJobInfo": "La información del puesto no existe",
      "person": "persona(s)",
      "recruitmentCount": "Número de vacantes:",
      "salary": "Condiciones salariales:",
      "suzhou": "Suzhou",
      "workLocation": "Lugar de trabajo:",
      "workYear": "Años de experiencia:"
    },
    "contact": {
      "address": "Dirección:",
      "contactInfo": "Información de contacto",
      "email": "Correo electrónico:",
      "errors": {
        "getContactFailed": "Fallo al obtener datos de información de contacto"
      },
      "pageTitle": "Contáctanos",
      "phone": "Teléfono:",
      "postcode": "Código postal:"
    },
    "page": {
      "careers": {
        "activities": {
          "balance": {
            "description": "Promover el equilibrio entre trabajo y vida",
            "subtitle": "KEEP BALANCED",
            "title": "Equilibrio para avanzar"
          },
          "learning": {
            "description": "Construir una organización de aprendizaje y promover el aprendizaje permanente",
            "subtitle": "KEEP LEARNING",
            "title": "El aprendizaje no tiene fin"
          }
        },
        "category": "Categoría:",
        "errors": {
          "getAreaFailed": "Fallo al obtener el lugar de trabajo",
          "getAreaFailedRetry": "Fallo al obtener el lugar de trabajo, intente nuevamente más tarde",
          "getCategoryFailed": "Fallo al obtener categorías de puestos",
          "getCategoryFailedRetry": "Fallo al obtener categorías de puestos, intente nuevamente más tarde",
          "getJobsFailed": "Fallo al obtener la lista de puestos",
          "getJobsFailedRetry": "Fallo al obtener la lista de puestos, intente nuevamente más tarde",
          "getNatureFailed": "Fallo al obtener la naturaleza del trabajo",
          "getNatureFailedRetry": "Fallo al obtener la naturaleza del trabajo, intente nuevamente más tarde"
        },
        "jobCategory": "Categoría de puesto",
        "jobNature": "Naturaleza del trabajo",
        "nationwide": "Todo el país",
        "noData": "No hay datos disponibles",
        "noJobs": "No hay puestos relacionados disponibles",
        "publishDate": "Publicado",
        "searchBox": {
          "campusRecruitment": "Reclutamiento en campus",
          "placeholder": "Ingrese palabras clave",
          "search": "Buscar",
          "socialRecruitment": "Reclutamiento social"
        },
        "viewDetail": "Ver detalles >",
        "workLocation": "Lugar de trabajo"
      },
      "company": {
        "companyIntro": "Fundada en 2003 con sede en Suzhou, China, tras años de desarrollo innovador, se ha convertido en una empresa nacional de alta tecnología que integra I+D, producción, ventas y servicio. Su ámbito de negocio cubre ciencias de la vida, cuidado personal, nuevos materiales, selección de productos de investigación, pruebas, etc.",
        "companyName": "Yacoo Science.",
        "dataSection": {
          "founded": "Fundación",
          "globalCustomers": "Clientes globales",
          "globalPartners": "Socios ecológicos globales",
          "patents": "Patentes solicitadas en China y el extranjero",
          "productionBase": "Capacidad de producción anual",
          "salesCountries": "Países y regiones de venta",
          "title": "Datos de la empresa",
          "unit": "toneladas",
          "year": "año(s)"
        },
        "history": {
          "title": "Historial de desarrollo"
        },
        "honor": {
          "title": "Honores y calificaciones"
        },
        "pageTitle": "Acerca de la empresa",
        "subtitle": "Yacoo Science es el líder innovador en materiales médico-químicos globales.",
        "vision": {
          "mission": {
            "description": "Dedicado a promover el progreso tecnológico y la innovación en materiales farmacéuticos y químicos",
            "title": "Misión"
          },
          "title": "Filosofía empresarial",
          "values": {
            "description": "Integridad y gratitud, responsabilidad y diligencia, pragmatismo y esfuerzo, innovación y excelencia",
            "title": "Valores fundamentales"
          },
          "vision": {
            "description": "Convertirse en el líder innovador global en materiales farmacéuticos y químicos",
            "title": "Visión"
          }
        }
      },
      "production": {
        "intro": "Yacoo Science. cuenta con capacidad de fabricación estable y confiable. Actualmente, ha establecido dos bases de producción en Jining y Anqing, equipadas con equipos y procesos de producción de vanguardia internacional, centrándose en la investigación, desarrollo y producción de productos químicos finos de alta calidad. La capacidad total de producción de cada base supera las 100.000 toneladas al año, y ha obtenido la certificación del sistema de gestión de calidad ISO 9001, el sistema de gestión ambiental ISO 14001 y el sistema de gestión de salud y seguridad ocupacional ISO 45001.",
        "intro2": "Yacoo Science. garantiza que cada lote de productos cumpla con los estándares industriales altos a través del sistema de control de calidad 'cero defectos', y sigue brindando soluciones estables y confiables de suministro de productos químicos a clientes de todo el mundo. Basada en las ventajas competitivas de capacidad de producción a gran escala, producción inteligente y control integral de materias primas, ofrece soluciones integrales de materias primas 'desde la investigación científica hasta la producción comercial' para industrias emergentes estratégicas como la salud médica y la biotecnología, ayudando a los clientes a lograr un desarrollo sólido.",
        "siteInfo": {
          "area": "Área ocupada:",
          "capacity": "Talleres y capacidad de producción:",
          "coreProducts": "Productos principales:",
          "field": "Campos de aplicación:"
        },
        "title": "Bases de producción"
      },
      "quality": {
        "equipment": {
          "description": "Al establecer una plataforma completa de equipos de prueba, que incluye cromatógrafos líquidos de alta eficacia, cromatógrafos de gases, espectrómetros de resonancia magnética nuclear, polarímetros, espectrómetros de infrarrojo, espectrómetros de emisión de plasma acoplado por inducción, tituladores automáticos de potencial y medidores de humedad por método Karl Fischer, entre otros, Yacoo Science. puede satisfacer las necesidades de prueba de liberación de alta precisión y complejidad para clientes en diversas situaciones.",
          "devices": {
            "automaticTitrator": "Titulador automático de potencial",
            "broadbandNMR": "Espectrómetro de resonancia magnética nuclear de bobina múltiple de banda ancha",
            "gcms": "GC-MS (Cromatografía de gases - Espectrometría de masas)",
            "icpSpectrometer": "Espectrómetro de emisión de plasma acoplado por inducción",
            "infraredSpectrometer": "Espectrómetro de infrarrojo",
            "karlFischer": "Medidor de humedad por método Karl Fischer (coulométrico)"
          },
          "title": "Equipos de prueba"
        },
        "intro": "Yacoo Science. garantiza la calidad de los productos a través del control de procesos, centrándose en brindar a los clientes productos diversos con mayor relación calidad-precio y servicios de mayor calidad, tomando como responsabilidad su propia el servicio para la innovación de los clientes. Basada en 22 años de experiencia acumulada en pruebas de materiales farmacéuticos y químicos, Yacoo Science., con un equipo de análisis científico liderado por varios doctores, ofrece soluciones integrales a los clientes desde la prueba hasta la optimización tecnológica.",
        "intro2": "La plataforma de prueba propiedad de Yacoo Science. cuenta con laboratorios modernos de 3.000 m², y ha establecido un sistema de circulación y purificación de aire líder en China, garantizando un entorno de prueba seguro y controlado. La plataforma está equipada con espacios completos de análisis químico y conjuntos completos de equipos de alta gama, satisfaciendo las necesidades de pruebas de alta precisión y complejidad. Según las leyes, regulaciones y normativas técnicas de diversos países/regiones (como el REACH de la UE, la FDA de EE.UU. y el CDE de China), ayuda a los clientes a evitar barreras comerciales y lograr la gestión de conformidad durante todo el ciclo de vida del producto.",
        "navigation": {
          "next": "Siguiente",
          "prev": "Anterior"
        },
        "system": {
          "description": "Yacoo Science. ha establecido un sistema completo de prueba de materiales farmacéuticos y químicos que abarca caracterización estructural, propiedades físico-químicas, análisis de elementos, análisis espectral, estudios de estabilidad, trazabilidad completa de datos, estudios de análisis de impurezas y pruebas de materias primas y aditivos. La gestión de calidad ha obtenido la certificación del sistema GMP y el sistema de gestión de calidad ISO 9001:2015, apoyando el desarrollo y aplicación de clientes en mercados globales.",
          "title": "Sistema de prueba"
        },
        "title": "Gestión de calidad"
      }
    },
    "tabs": {
      "careers": "Únete a nosotros",
      "company": "Acerca de la empresa",
      "production": "Bases de producción",
      "quality": "Gestión de calidad"
    }
  },
  "dzhc": {
    "businessIntroText": "Los servicios personalizados son el negocio central de Yacoo Science. Basada en 22 años de experiencia acumulada en investigación y desarrollo en el campo de materiales farmacéuticos y químicos, Yacoo Science. puede brindar a los clientes servicios personalizados integrales, confiables y estables. Contamos con un equipo de investigación y desarrollo y un equipo de control de calidad compuesto por científicos y ingenieros experimentados, hemos establecido cinco plataformas experimentales como la plataforma de síntesis inteligente con IA, la plataforma de síntesis química y la plataforma de síntesis biológica, y está equipada con plataformas de prueba avanzadas como cromatógrafos líquidos de alta eficacia, cromatógrafos de gases y polarímetros. Además, Yacoo Science. tiene dos bases de producción con capacidad de producción anual superior a las 100.000 toneladas, capaz de satisfacer las necesidades completas de los clientes en el campo de materiales farmacéuticos y químicos, desde la síntesis personalizada y servicios CRO hasta servicios CDMO.",
    "businessIntroTitle": "Panorama del negocio",
    "businessItems": ["Materiales poliméricos", "Monómeros de polímeros", "Intermediarios farmacéuticos", "Nuevos materiales electroquímicos", "Materias primas para pruebas clínicas"],
    "caseTabs": [
      {"title": "Equipo de expertos en el campo farmacéutico y químico", "description": "Compuesto por casi cien científicos e ingenieros experimentados, con más del 40% de profesionales con títulos de máster y doctor, ha solicitado más de 150 patentes de investigación y desarrollo, y más de 50 han sido aprobadas."},
      {"title": "Plataformas de investigación, desarrollo y prueba de primer nivel", "description": "Establecimiento de cinco plataformas experimentales como la plataforma de síntesis inteligente con IA, la plataforma de síntesis química y la plataforma de síntesis biológica, equipadas con plataformas de prueba avanzadas como cromatógrafos líquidos de alta eficacia, cromatógrafos de gases y polarímetros."},
      {"title": "Garantía de sistema de calidad internacional", "description": "Cumplimiento estricto con estándares internacionales ISO, control de calidad en todo el proceso para garantizar la alta confiabilidad de los productos. Desde la selección de materias primas hasta el producto terminado, hay nodos de prueba de múltiples niveles y control de calidad en todo el proceso."}
    ],
    "coreBusinessTitle": "Negocio central",
    "featureTitle": "Características del servicio",
    "pageSubtitle": "Servicios personalizados CRO+CDMO para productos farmacéuticos y químicos",
    "pageTitle": "Servicios personalizados",
    "processItems": [
      {"title": "Diseño de ruta", "desc": ["Más de 100 investigadores con experiencia", "Diseño de ruta de síntesis asistido por IA"]},
      {"title": "Investigación, desarrollo y síntesis", "desc": ["Laboratorios de investigación y desarrollo de más de 10.000 m²", "Cobertura de 80% de reacciones comunes"]},
      {"title": "Producción de muestras", "desc": ["Producción en fábricas de más de 200.000 m²", "Control de calidad estricto, garantía de calidad"]},
      {"title": "Envasado y envío", "desc": ["Cumplimiento con diversos requisitos de envasado y envío de sólidos/líquidos", "Envío profesional de muestras/seguimiento logístico"]}
    ],
    "processTitle": "Proceso de síntesis personalizada",
    "startProject": "Inicie su proyecto personalizado ahora",
    "startProjectDesc": "Exponga sus necesidades, y nuestro equipo profesional le brindará consultoría técnica individual y soluciones personalizadas.",
    "viewMore": "Ver más"
  },
  "header": {
    "contactUs": "Contáctanos",
    "menu": {
      "about": "Acerca de Yacoo",
      "companyProfile": "Perfil de la empresa",
      "customSynthesis": "Servicios personalizados",
      "greenEnergy": "Energía verde",
      "innovation": "Logros de innovación",
      "joinUs": "Únete a nosotros",
      "news": "Centro de noticias",
      "other": "Otros negocios",
      "production": "Bases de producción",
      "products": "Centro de productos",
      "quality": "Gestión de calidad",
      "rAndDSystem": "Sistema de investigación y desarrollo",
      "researchPurchase": "Compras científicas",
      "smartPlatform": "Plataforma inteligente",
      "solution": "Soluciones industriales",
      "sustainability": "Desarrollo sostenible",
      "technology": "Investigación, desarrollo e innovación",
      "testingService": "Servicios de prueba"
    },
    "searchPlaceholder": "Ingrese contenido de búsqueda..."
  },
  "home": {
    "about": {
      "description": "Fundada en 2003 con sede en Suzhou, China, tras años de desarrollo innovador, se ha convertido en una empresa nacional de alta tecnología que integra I+D, producción, ventas y servicio. Su ámbito de negocio cubre ciencias de la vida, cuidado personal, nuevos materiales, selección de productos de investigación, pruebas, etc.",
      "learnMore": "Saber más",
      "subtitle": "Yacoo Science es el líder innovador en materiales médico-químicos globales.",
      "title": "Acerca de Yacoo"
    },
    "globalService": {
      "description": "Yacoo Science, puede brindar a clientes globales servicios integrales CRO+CMO desde lasíntesis personalizada hasta la producción a gran escala, satisfaciendo las necesidades completas de sus productos desde la investigación científica hasta la producción comercial.",
      "legend": {
        "customers": {
          "en": "Our Customers",
          "zh": "Clientes atendidos"
        },
        "headquarters": {
          "en": "Yacoo Headquarter",
          "zh": "Sede central de Yacoo"
        },
        "subsidiaries": {
          "en": "Subsidiary Companies",
          "zh": "Subsidiarias de Yacoo"
        }
      },
      "stats": {
        "title": "Distribución internacional",
        "capacity": "Establecimiento de subsidiarias en Singapur, Estados Unidos y Alemania",
        "patents": "Más de 15.000 clientes globales",
        "team": "Cobertura comercial en más de 70 países del mundo"
      },
      "title": "Red de servicios globales"
    },
    "news": {
      "noNews": "No hay noticias relacionadas disponibles",
      "pageTitle": "Centro de noticias",
      "searchPlaceholder": "Ingrese palabras clave",
      "title": "Noticias de Yacoo",
      "topTag": "Destacado",
      "viewDetail": "Saber detalles",
      "viewMore": "Ver más"
    },
    "solutions": {
      "title": "Productos y soluciones"
    }
  },
  "jcfw": {
    "businessIntroText1": "Wonder Testing es una plataforma independiente de servicios de prueba perteneciente a Yacoo Science. Basada en 22 años de experiencia acumulada en pruebas de materiales farmacéuticos y químicos de Yacoo Science., Wonder Testing se dedica a construir una plataforma internacional de servicios de calidad. Según la certificación de cualificación CMA (Certificación Metrológica China) y la acreditación de laboratorios CNAS (ISO/IEC 17025), brinda servicios de prueba, certificación y consultoría correspondiente según leyes, regulaciones y normativas técnicas (de diversos países/regiones) a empresas manufactureras y empresas comerciales nacionales y extranjeras. Ofrece soluciones integrales a los clientes desde la prueba hasta la optimización tecnológica.",
    "businessIntroText2": "La plataforma Wonder Testing cuenta con laboratorios modernos de 3.000 m², y ha establecido un sistema de circulación y purificación de aire líder en China, garantizando un entorno de prueba seguro y controlado. La plataforma está equipada con espacios completos de análisis químico y conjuntos completos de equipos de alta gama, satisfaciendo las necesidades de pruebas de alta precisión y complejidad. Según las leyes, regulaciones y normativas técnicas de diversos países/regiones (como el REACH de la UE, la FDA de EE.UU. y el CDE de China), ayuda a los clientes a evitar barreras comerciales y lograr la gestión de conformidad durante todo el ciclo de vida del producto.",
    "businessIntroTitle": "Panorama del negocio",
    "businessItems": ["Servicios de inspección y prueba", "Investigación médica y desarrollo experimental", "Servicios de tecnología de prueba", "Servicios de certificación"],
    "businessItemsClass": ["Bienes de consumo diario", "Productos electrónicos y eléctricos", "Juguetes y artículos para niños", "Materiales en contacto con alimentos", "Materiales automotrices", "Productos ligeros y textiles"],
    "businessTip": "El laboratorio ha establecido un sistema completo de servicios de prueba, capaz de satisfacer las necesidades de prueba química y física de bienes de consumo diario, productos electrónicos y eléctricos, juguetes y artículos para niños, materiales en contacto con alimentos, materiales automotrices, productos ligeros y textiles, etc.",
    "caseTabs": [
      {"title": "Experiencia en prueba y certificación de conformidad", "description": "El laboratorio se apoya en 22 años de experiencia en servicios de prueba de Yacoo Science. en el campo farmacéutico y químico, dedicándose a brindar servicios de prueba de conformidad, certificación y consultoría técnica a empresas manufactureras y comerciales globales."},
      {"title": "Certificación de sistema de estándares internacionales", "description": "Los indicadores de prueba y el sistema de gestión cumplen con los requisitos de los sistemas de calidad internacionales, y ha obtenido el reconocimiento de numerosos clientes líderes internacionales, garantizando la autoridad y credibilidad de los datos de prueba."},
      {"title": "Cobertura completa de capacidades de prueba", "description": "Brinda servicios completos en campos como prueba química de productos de consumo, evaluación de seguridad de juguetes para niños, prueba de textiles, prueba de conformidad de materiales en contacto con alimentos y análisis de materiales automotrices, ayudando a las empresas a cumplir con los requisitos regulatorios de diversos países (como REACH, FDA, CDE, etc.)"}
    ],
    "contact": {
      "address": "Dirección: Piso 8, No. 112, Calle Xinqing, Parque Industrial de Suzhou",
      "email": "Correo de contacto: service@wondertesting.cn",
      "phone": "Teléfono: +86-18625246998",
      "postcode": "Código postal: 215121"
    },
    "contactTitle": "Contáctanos",
    "coreBusinessTitle": "Negocio central",
    "equipmentDesc": "Al establecer una plataforma completa de equipos de prueba, que incluye cromatógrafos líquidos de alta eficacia, cromatógrafos de gases, espectrómetros de resonancia magnética nuclear, polarímetros y espectrómetros de infrarrojo, entre otros, Yacoo Science. puede satisfacer las necesidades de prueba de liberación de alta precisión y complejidad para clientes en diversas situaciones.",
    "equipmentList": ["Espectrómetro de infrarrojo", "Espectrómetro de resonancia magnética nuclear de bobina múltiple de banda ancha", "Espectrómetro de emisión de plasma acoplado por inducción", "Medidor de humedad por método Karl Fischer (coulométrico)", "GC-MS (Cromatografía de gases - Espectrometría de masas)", "Titulador automático de potencial"],
    "equipmentTitle": "Equipos de prueba",
    "featureTitle": "Características del servicio",
    "nextBtn": "Siguiente",
    "pageSubtitle": "Proveedor integrado desde prueba independiente hasta optimización tecnológica",
    "pageTitle": "Servicios de prueba",
    "platformDesc": "Proveedor integrado de servicios de prueba y certificación",
    "prevBtn": "Anterior",
    "shopSubtitle": "Proveedor integrado desde prueba independiente hasta optimización tecnológica",
    "shopTitle": "Wonder Testing",
    "viewMore": "Ver más"
  },
  "kycg": {
    "businessIntroText": "Element Mall (www.b2star.com) es una plataforma de comercio electrónico profesional para compras integrales de artículos científicos perteneciente a Yacoo Science. Al integrar canales de proveedores de marcas de calidad nacionales y extranjeras, ofrece productos profesionales como reactivos científicos, artículos de protección, suministros biológicos y equipos de laboratorio, dedicándose a satisfacer mejor las necesidades diversificadas de clientes nacionales y extranjeros en campos como investigación en ciencias de la vida, biotecnología farmacéutica y nuevos materiales.",
    "businessIntroTitle": "Panorama del negocio",
    "businessItems": [
      {"title": "Reactivos científicos", "desc": "Reactivos biológicos, reactivos químicos, reactivos de análisis, otros reactivos"},
      {"title": "Artículos de protección", "desc": "Protección para manos, protección para cabeza, protección para rostro, otra protección"},
      {"title": "Suministros biológicos", "desc": "Cultivo celular, suministros médicos, suministros para cromatografía, suministros para prueba, suministros para pipeteo, suministros de herramientas"},
      {"title": "Equipos de laboratorio", "desc": "Instrumentos常规 (convencionales), instrumentos de prueba, instrumentos de cromatografía, instrumentos especializados, instalaciones de seguridad"}
    ],
    "caseTabs": [
      {"title": "Respuesta de envío en 24 horas", "description": "Envío directo desde múltiples almacenes, entrega rápida"},
      {"title": "Más de 6 millones de especificaciones de productos", "description": "Numerosas marcas, variedad completa de categorías"},
      {"title": "Más de 600 marcas colaboradoras reconocidas", "description": "Autorización de fabricantes, garantía de autenticidad"},
      {"title": "Servicios de compra atentos", "description": "Muchas ventajas, servicio profesional"}
    ],
    "contact": {
      "addressSuqian": "Dirección (Suqian): Piso 1, Edificio Guke (Torre A9), Parque de Comercio Electrónico, Distrito Suyu, Ciudad Suqian",
      "addressSuzhou": "Dirección (Suzhou): No. 112, Calle Xinqing, Parque Industrial de Suzhou",
      "addressWuhan": "Dirección (Wuhan): Piso 11, Habitación 07, Edificio T3, Centro de Sede de Guanggu, No. 766, Calle Gaoxin, Distrito de Tecnología Nueva del Este del Lago Wuhan",
      "addressChengdu": "Dirección (Chengdu): Habitación 706, Edificio 3, Dingxin Electrónico, Calle Wukesong Oeste 1, Distrito Wuhou, Ciudad Chengdu",
      "email": "Correo electrónico: sxg@b2star.com",
      "phone": "Teléfono: 15335295587"
    },
    "contactTitle": "Contáctanos",
    "coreBusinessTitle": "Negocio central",
    "enterShop": "Ingresar para encargar",
    "featureTitle": "Características del servicio",
    "pageSubtitle": "Plataforma integral de compras científicas",
    "pageTitle": "Compras científicas",
    "shopBusiness": ["Reactivos científicos", "Protección de seguridad", "Suministros biológicos", "Equipos de laboratorio"],
    "shopSubtitle": "Plataforma integral de compras científicas",
    "shopTitle": "Element Mall"
  },
  "lsny": {
    "businessIntroText": "Goodenough New Energy (www.goodenoughchem.com) es una plataforma de servicios de energía verde perteneciente a Yacoo Science. El agente de curado in situ ignífugo desarrollado independientemente mejora eficazmente la seguridad de las baterías y ha obtenido el reconocimiento de colaboración de numerosas empresas líderes. Como proveedor integrado de materiales de baterías de litio para energía nueva, Goodenough New Energy puede satisfacer todas las necesidades de los clientes desde requisitos de investigación científica hasta producción a gran escala, brindando configuración de electrolito básico, materias primas de electrolito, electrolito con funciones especiales y servicios profesionales de configuración de electrolito en grandes cantidades/servicios de personalización de electrolito.",
    "businessIntroTitle": "Panorama del negocio",
    "businessItems": [
      {"title": "Electrolito"},
      {"title": "Reactivos químicos"},
      {"title": "Materiales de baterías"},
      {"title": "Electrolito con funciones especiales"}
    ],
    "caseTabs": [
      {"title": "Amplia gama de productos", "description": "Ha completado el desarrollo de casi cien tipos de aditivos funcionales para baterías de litio para energía nueva, y puede brindar electrolito para litio/sodio/magnesio/aluminio"},
      {"title": "Desarrollo, personalización y producción en grandes volúmenes", "description": "Capacidad de industrialización de más de 10 tipos de materiales funcionales para baterías de litio, entre los cuales la capacidad planificada de productos de la serie etoxifosfazina alcanza el nivel de cientos de toneladas"},
      {"title": "Reconocimiento de colaboración con empresas líderes", "description": "Los indicadores de productos de agentes ignífugos sólidos alcanzan el nivel internacional, y han obtenido el reconocimiento de numerosas empresas líderes de energía nueva en China"}
    ],
    "contactAddress": "Dirección: Piso 8, No. 112, Calle Xinqing, Parque Industrial de Suzhou",
    "contactEmail": "Correo electrónico: sales022@b2star.com",
    "contactPhone": "Teléfono: 18136447806",
    "contactPostcode": "Código postal: 215121",
    "contactQQ": "QQ: 693755679",
    "contactSubtitle": "Proveedor integrado de materiales de baterías de litio para energía nueva",
    "contactTitle": "Contáctanos",
    "coreBusinessTitle": "Negocio central",
    "enterShop": "Saber más",
    "featureTitle": "Características del servicio",
    "pageSubtitle": "Proveedor integrado de materiales de baterías de litio para energía nueva",
    "pageTitle": "Energía verde",
    "shopSubtitle": "Proveedor integrado de materiales de baterías de litio para energía nueva",
    "shopTitle": "Goodenough New Energy"
  },
  "news": {
    "searchBtn": "Buscar",
    "noNews": "No hay noticias relacionadas disponibles",
    "pageTitle": "Centro de noticias",
    "searchPlaceholder": "Ingrese palabras clave",
    "title": "Noticias de Yacoo",
    "topTag": "Destacado",
    "viewDetail": "Saber detalles",
    "viewMore": "Ver más"
  },
  "products": {
    "centerTitle": "Centro de productos",
    "detail": {
      "advantages": "Ventajas del servicio",
      "batchInquiry": "Consulta de compra por lote",
      "breadcrumbCenter": "Centro de productos",
      "breadcrumbHome": "Página de inicio",
      "cas": "CAS: {cas}",
      "customSynthesis": "Consulta de síntesis personalizada",
      "featured": "Productos populares recomendados",
      "features": "Características del producto",
      "getSample": "Obtener muestra",
      "noData": "No hay datos disponibles",
      "notes": "Notas",
      "related": "Productos relacionados recomendados",
      "researchPurchase": "Compras científicas"
    },
    "mainProducts": "Productos principales",
    "noData": "No hay datos disponibles",
    "searchBtn": "Consultar",
    "searchPlaceholder": "Ingrese nombre de producto, código de producto, número CAS o palabras clave",
    "panel": {
      "EnglishName": "Nombre en inglés",
      "Name": "Nombre del producto",
      "Alias": "Nombre alternativo",
      "CAS": "Número CAS",
      "UsagePlatform": "Plataforma de aplicación",
      "ArtNo": "Código de producto",
      "molecularFormula": "Fórmula molecular",
      "molecularWeight": "Peso molecular",
      "ec": "Número EC",
      "enzymeActivity": "Actividad enzimática",
      "activity": "Actividad"
    }
  },
  "solution": {
    "learnMore": "Saber más",
    "pageSubtitle": "Promover el progreso tecnológico y la innovación en materiales farmacéuticos y químicos",
    "pageTip": "Yacoo Science. siempre se ha centrado en promover el progreso tecnológico y la innovación en materiales farmacéuticos y químicos. Basada en la innovación tecnológica y el suministro sólido, satisface las necesidades profesionales de los clientes, brinda productos diversos y servicios de alta calidad, conveniencia y mayor relación calidad-precio, promueve el progreso continuo de la industria de materiales farmacéuticos y químicos, y construye juntos un futuro verde y saludable.",
    "pageTitle": "Soluciones industriales",
    "tableName": "Nombre"
  },
  "sustainability": {
    "conceptText": "Yacoo Science Shares siempre se ha adherido al concepto de desarrollo sostenible, integrando la innovación verde en todo el proceso de investigación y desarrollo, producción y operaciones. Nos dedicamos a reducir la huella de carbono mediante la optimización de procesos ambientales, el reciclaje de recursos y la aplicación de energías limpias; impulsamos el desarrollo de materiales biodegradables y soluciones ecológicas a través de la innovación tecnológica, contribuyendo a la transición baja en carbono de la industria. Al mismo tiempo, cumplimos activamente con nuestra responsabilidad social, construyendo un sistema de beneficio mutuo para empleados, comunidades y el medio ambiente, buscando el desarrollo coordinado de beneficios económicos, ecológicos y sociales, y contribuyendo a los objetivos globales de desarrollo sostenible.",
    "conceptTitle": "Filosofía de desarrollo sostenible",
    "dataSection": {
      "highConcentrationGas": "Proporción de consumo de energía verde",
      "lowConcentrationGas": "Equivalente de dióxido de carbono/millón de yuan",
      "solidWasteStorage": "Donación de libros a la Escuela Secundaria No. 2 de Kezhou, Xinjiang",
      "wastewaterTreatment": "Donaciones benéficas sociales en 2024",
      "units": {
        "cubicMeterPerHour": "%",
        "ton": "toneladas",
        "tonPerDay": "ejemplares",
        "yuan": "yuanes"
      }
    },
    "environmentalProtection": {
      "altText": "Protección del medio ambiente",
      "description": "Yacoo Science. cumple estrictamente con las leyes, regulaciones y otras disposiciones relacionadas con la protección del medio ambiente a nivel nacional y local, y ha obtenido la certificación del sistema de gestión ambiental ISO 14001. Cuenta con instalaciones completas para el tratamiento de residuos tres (agua residual, gases residuales y residuos sólidos). Al introducir instalaciones avanzadas para el tratamiento de agua residual, gases residuales y residuos sólidos, la empresa puede desarrollar actividades de producción de manera segura mientras garantiza la protección del medio ambiente.",
      "title": "Protección del medio ambiente"
    },
    "greenDevelopment": {
      "buildingAlt": "Edificio de la sede central de Yacoo Science.",
      "description": "Abrazando el espíritu empresarial de 'Superar los límites de la farmacia y la química, construir juntos un futuro verde', Yacoo Science. siempre ha tomado el desarrollo verde como responsabilidad tanto en la construcción de infraestructuras básicas como en el desarrollo de productos. El edificio de la sede del grupo ha obtenido el certificado LEED (Leadership in Energy and Environmental Design) de nivel Platino emitido por el Consejo de Edificios Verdes de EE.UU., y puede suministrar energía a través de equipos de energía verde como paneles solares. Yacoo Science. se basa en materiales biológicos biodegradables producidos a partir de cultivos renovables (como el poliéster de etilenglicol y 2,5-furandicarboxílico, PEF), que pueden aplicarse ampliamente en el campo de envases de botellas, reduciendo significativamente la huella de carbono total durante el proceso de producción del producto.",
      "title": "Desarrollo verde"
    },
    "pageSubtitle": "Servicios personalizados CRO+CDMO para productos farmacéuticos y químicos",
    "pageTitle": "Desarrollo sostenible",
    "safetyProduction": {
      "certificateAlt": "Certificado de acreditación ambiental",
      "description": "Yacoo ha establecido un sistema completo de gestión de producción segura según los requisitos del sistema de gestión de salud y seguridad ocupacional ISO 45001. Se apoya en instalaciones tecnológicas inteligentes y basadas en la información para proteger la línea de vida segura. Por ejemplo, la base de producción de Yacoo en Anqing ha obtenido la certificación de estandarización de producción segura de nivel III, ha establecido un sistema informático de producción segura y cuenta con un sistema completo de prevención y control de riesgos de seguridad desde cinco aspectos: localización de personal, inspección inteligente, prevención doble, etc.",
      "title": "Producción segura"
    }
  },
  "technology": {
    "achievementsTitle": "Logros de innovación",
    "businessIntroText": "Yacoo Science. cuenta con un centro de investigación y desarrollo de más de 10.000 m², equipado con instalaciones de vanguardia como la plataforma de síntesis con IA y reactores de flujo continuo de microcanal, y ha formado un equipo de investigación de más de cien personas, con titulados de máster y doctor como núcleo. A través de cooperaciones profundas en investigación científica y aplicación con institutos como el Instituto de Materiales de Ningbo del Academia Sinica y la Universidad de Suzhou, la empresa ha establecido plataformas de innovación como el 'Centro de Investigación y Desarrollo Tecnológico de Jiangsu' y el 'Centro de Innovación Conjunto Yacoo-JITRI', formando un sistema completo de investigación, desarrollo y conversión de resultados. Hasta la fecha, la empresa ha solicitado más de 150 patentes.",
    "businessIntroTitle": "Sistema de investigación y desarrollo completo",
    "businessItems": [
      {"title": "Purificantes biomédicos y productos químicos estructurales"},
      {"title": "Desarrollo de reactores de diagnóstico in vitro de alta gama"},
      {"title": "Desarrollo de enzimas biológicas"},
      {"title": "Desarrollo de materiales poliméricos biológicos de alta calidad"},
      {"title": "Productos químicos electrónicos de nivel semiconductor y materiales de baterías para energía nueva"}
    ],
    "consultBtn": "Consulta de personalización",
    "customServiceDesc": "Basada en 22 años de experiencia acumulada en investigación y desarrollo en el campo de materiales farmacéuticos y químicos, Yacoo Science. puede brindar a los clientes servicios de síntesis personalizada confiables y estables.",
    "customServiceTitle": "Servicios de personalización desde nivel de gramos hasta nivel de toneladas",
    "leadingProcess": "Procesos líderes",
    "pageTitle": "Tecnología impulsada por inteligencia, creando el futuro innovador",
    "platformList": [
      {"title": "Laboratorio inteligente con IA", "description": "El laboratorio de síntesis inteligente con IA está equipado con un sintetizador inteligente con IA que permite personalizar pasos y parámetros de reacción, monitorear en tiempo real el proceso de reacción, lograr la selección rápida de condiciones de proceso y la predicción de condiciones óptimas de reacción, y mejorar la eficiencia de investigación y desarrollo."},
      {"title": "Laboratorio de purificación de reactores de alta calidad", "description": "Utilizado para la purificación de productos químicos de nivel excipiente farmacéutico y materiales electrónicos de nivel semiconductor. El laboratorio se centra en instalaciones de purificación avanzadas y puede realizar experimentos de tecnologías de destilación y filtración por membrana para compuestos como ácidos, alcoholes, aminas y nitriles."},
      {"title": "Plataforma de laboratorio especializada para electrolitos de energía nueva", "description": "La plataforma puede realizar experimentos de agentes ignífugos para electrolitos y materiales de electrolitos. Está equipada con instalaciones profesionales y ha logrado el éxito en el desarrollo de agentes ignífugos de tipo fosfazina. La plataforma puede realizar el desarrollo continuo de materiales de baterías líquidas y semilíquidas según la ruta tecnológica de baterías específica del cliente."},
      {"title": "Plataforma de laboratorio de tecnología verde de síntesis biológica", "description": "La síntesis biológica se realiza en condiciones de temperatura y presión ambientales, con bajo consumo de energía, sin necesidad de solventes orgánicos y con reducción o eliminación de subproductos tóxicos. Esta plataforma se centra en el desarrollo de productos de tampones biológicos fabricados por tecnología de catálisis enzimática, y el desarrollo de nuevos sistemas de diagnóstico y materiales poliméricos biológicos."},
      {"title": "Plataforma de laboratorio de síntesis química", "description": "El laboratorio de síntesis química cuenta con instalaciones de síntesis tradicionales, además de instalaciones avanzadas como espectrómetro de resonancia magnética nuclear (NMR), espectrómetro de masas (MS), cromatógrafo líquido de alta eficacia (HPLC), estación de síntesis automática de flujo continuo de microcanal y sistema de gestión de datos de laboratorio (LIMS). Puede realizar el desarrollo de excipientes farmacéuticos, sustratos de diagnóstico in vitro y materiales compuestos poliméricos biológicos, incluyendo el desarrollo personalizado para clientes."}
    ],
    "platformTitle": "Cinco plataformas de investigación y desarrollo inteligentes",
    "serviceIcons": [
      "Purificantes biomédicos y productos químicos estructurales",
      "Desarrollo de reactores de diagnóstico in vitro de alta gama",
      "Desarrollo de enzimas biológicas",
      "Desarrollo de materiales poliméricos biológicos de alta calidad",
      "Productos químicos electrónicos de nivel semiconductor y materiales de baterías para energía nueva"
    ],
    "starProduct": "Productos innovadores"
  },
  "footer": {
    "contact": {
      "phone": "Teléfono",
      "email": "Correo electrónico"
    },
    "qrCode": {
      "scanToFollow": "Escanee el código QR para seguirnos"
    },
    "socialMedia": {
      "wechat": "WeChat",
      "tiktok": "TikTok",
      "xiaohongshu": "Xiaohongshu"
    },
    "copyright": "© 2025 Yacoo Technology Suzhou Co., [Registro ICP de Jiangsu: No. 15045967]"
  },
  "croCdmoDialog": {
    "logoAlt": "Logotipo de Yacoo",
    "hotline": "Línea de servicio gratuita:",
    "description": "Por favor, deje sus información de necesidades y nos pondremos en contacto con usted en 1 día hábil",
    "form": {
      "name": "Nombre",
      "namePlaceholder": "Por favor, ingrese su nombre",
      "contact": "Información de contacto",
      "contactPlaceholder": "Por favor, ingrese su teléfono/móvil/correo electrónico",
      "company": "Nombre de la empresa",
      "companyPlaceholder": "Por favor, ingrese el nombre de su empresa",
      "product": "Nombre del producto",
      "productPlaceholder": "Por favor, ingrese el nombre del producto",
      "cas": "Número CAS",
      "casPlaceholder": "Por favor, ingrese el número CAS",
      "requirement": "Requisitos de compra",
      "requirementPlaceholder": "Por favor, ingrese sus requisitos de compra",
      "attachment": "Adjunto",
      "submit": "Enviar"
    },
    "upload": {
      "clickToUpload": "Haga clic para subir el adjunto",
      "fileFormat": "Formato de archivo: jpg, pdf, doc, tamaño máximo 5 MB",
      "fileSizeError": "El tamaño del archivo no puede exceder 5 MB",
      "fileTypeError": "Por favor, suba un archivo en formato jpg, pdf o doc",
      "uploadSuccess": "Archivo subido con éxito",
      "uploadFailed": "Fallo al subir el archivo, por favor intente nuevamente"
    },
    "validation": {
      "nameRequired": "Por favor, ingrese su nombre",
      "contactRequired": "Por favor, ingrese información de contacto",
      "casRequired": "Por favor, ingrese el número CAS"
    },
    "messages": {
      "submitSuccess": "Envío exitoso",
      "submitFailed": "Fallo al enviar",
      "submitFailedRetry": "Fallo al enviar, por favor intente nuevamente más tarde"
    }
  },
  "productDialog": {
    "logoAlt": "Logotipo de Yacoo",
    "hotline": "Línea de servicio gratuita:",
    "description": "Por favor, deje sus información de necesidades y nos pondremos en contacto con usted en 1 día hábil",
    "form": {
      "name": "Nombre",
      "namePlaceholder": "Por favor, ingrese su nombre",
      "contact": "Información de contacto",
      "contactPlaceholder": "Por favor, ingrese su teléfono/móvil/correo electrónico",
      "company": "Nombre de la empresa",
      "companyPlaceholder": "Por favor, ingrese el nombre de su empresa",
      "product": "Nombre del producto",
      "productPlaceholder": "Por favor, ingrese el nombre del producto",
      "cas": "Número CAS",
      "casPlaceholder": "Por favor, ingrese el número CAS",
      "requirement": "Requisitos de compra",
      "requirementPlaceholder": "Por favor, ingrese sus requisitos de compra",
      "submit": "Enviar"
    },
    "validation": {
      "nameRequired": "Por favor, ingrese su nombre",
      "contactRequired": "Por favor, ingrese información de contacto",
      "casRequired": "Por favor, ingrese el número CAS"
    },
    "messages": {
      "submitSuccess": "Envío exitoso",
      "submitFailed": "Fallo al enviar",
      "submitFailedRetry": "Fallo al enviar, por favor intente nuevamente más tarde"
    }
  },
  "serviceDialog": {
    "logoAlt": "Logotipo de Yacoo",
    "hotline": "Línea de servicio gratuita:",
    "description": "Por favor, deje sus información de necesidades y nos pondremos en contacto con usted en 1 día hábil",
    "form": {
      "name": "Nombre",
      "namePlaceholder": "Por favor, ingrese su nombre",
      "contact": "Información de contacto",
      "contactPlaceholder": "Por favor, ingrese su teléfono/móvil/correo electrónico",
      "company": "Nombre de la empresa",
      "companyPlaceholder": "Por favor, ingrese el nombre de su empresa",
      "service": "Nombre del servicio",
      "servicePlaceholder": "Por favor, ingrese el nombre del servicio",
      "requirement": "Descripción detallada de necesidades",
      "requirementPlaceholder": "Por favor, ingrese sus necesidades de personalización",
      "submit": "Enviar"
    },
    "validation": {
      "nameRequired": "Por favor, ingrese su nombre",
      "contactRequired": "Por favor, ingrese información de contacto"
    },
    "messages": {
      "submitSuccess": "Envío exitoso",
      "submitFailed": "Fallo al enviar",
      "submitFailedRetry": "Fallo al enviar, por favor intente nuevamente más tarde"
    }
  },
  "purchaseDialog": {
    "logoAlt": "Logotipo de Yacoo",
    "title": "Más productos de marca, disponibles en Element Mall",
    "gotoStore": "Ir a la tienda para ver",
    "storeInfo": "Servicio proporcionado por Element Mall, perteneciente al Grupo Yacoo"
  },
  "purchaseListDialog": {
    "logoAlt": "Logotipo de Yacoo",
    "productInfo": "Información del producto",
    "unitPrice": "Precio unitario (incluye impuestos)",
    "more": "Más",
    "productCode": "Código de producto:",
    "itemNumber": "Código de artículo:",
    "specification": "Especificaciones:",
    "parameter": "Parámetros:",
    "contactSales": "Contactar con ventas para consultar precio",
    "gotoShop": "Ir a la tienda para ver",
    "storeInfo": "Servicio proporcionado por Element Mall, perteneciente al Grupo Yacoo"
  },
  "resumeDialog": {
    "logoAlt": "Yacoo",
    "upload": {
      "clickToUpload": "Haga clic para subir el currículum",
      "fileFormat": "Formato de archivo: jpg, pdf, ppt, tamaño máximo 5 MB",
      "fileSizeError": "El tamaño del archivo no puede exceder 5 MB",
      "fileTypeError": "Por favor, suba un archivo en formato jpg, pdf o ppt"
    },
    "fileInfo": {
      "removeFile": "Eliminar archivo"
    },
    "submit": "Enviar",
    "messages": {
      "uploadSuccess": "Currículum enviado con éxito",
      "uploadFailed": "Fallo al subir, por favor intente nuevamente",
      "jobNotExist": "La información del puesto no existe",
      "pleaseUploadFirst": "Por favor, suba el currículum primero"
    }
  },
  "goodChart": {
    "logoAlt": "Logotipo de Yacoo",
    "companyName": "Yacoo Science.",
    "consultationPhone": "Teléfono de consulta:",
    "productService": "Consultación de productos y servicio postventa:",
    "contactEmail": "Correo electrónico de contacto:",
    "leaveMessage": "Dejar mensaje"
  },
  "searchPage": {
    "pageTitle": "Búsqueda en todo el sitio",
    "searchInfo": "Búsqueda: {keyword}",
    "loading": "Cargando...",
    "noData": "No hay datos disponibles",
    "noNews": "No hay noticias relacionadas disponibles",
    "noProducts": "No hay productos relacionados disponibles",
    "productInfo": {
      "casNo": "Número CAS:",
      "itemNumber": "Código de artículo:",
      "specification": "Especificaciones:",
      "parameter": "Parámetros:",
      "price": "Precio:",
      "unit": "Unidad:",
      "inquiry": "Consultar",
      "chemicalName": "Nombre químico"
    },
    "newsInfo": {
      "typeTag": "Etiqueta de tipo"
    },
    "pagination": {
      "prev": "Página anterior",
      "next": "Página siguiente"
    }
  }
};


